import { Icon } from "@evergis/ui";
import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { formatNumber } from "utils/formatNumber";
import { DownloadErrorLogLink, ImportErrorsContainer, Message, MessageContent, MessageTitle } from "../styled";
import { ImportErrorsProps } from "../types";

const ImportErrorsComponent: FC<ImportErrorsProps> = ({ error, importInProgress }) => {
  const { t } = useTranslation("dialogs");
  const formattedErrorsCount = formatNumber(error.count);

  return (
    <ImportErrorsContainer>
      {error.message && (
        <Message warning>
          <Icon kind="warning" />
          <MessageContent>
            <MessageTitle>
              {t("import.importError")}: {error.message}
            </MessageTitle>
          </MessageContent>
        </Message>
      )}
      {!!error.count && (
        <Message warning>
          {importInProgress ? (
            <MessageTitle>
              {t("import.importErrors")}: {formattedErrorsCount}
            </MessageTitle>
          ) : (
            <DownloadErrorLogLink
              href={`data:text/plain;base64,${btoa(unescape(encodeURIComponent(error.log)))}`}
              download={"ImportErrorLog.txt"}
            >
              <Icon kind="upload" secondary />
              <MessageContent>
                <MessageTitle>
                  {t("import.importErrors")}: {formattedErrorsCount}
                </MessageTitle>
              </MessageContent>
            </DownloadErrorLogLink>
          )}
        </Message>
      )}
    </ImportErrorsContainer>
  );
};

export const ImportErrors = memo(ImportErrorsComponent);
